import React, { useEffect, useState } from "react";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import { Tabs, Tab, Spinner, Row, Col } from "react-bootstrap";
import PostDetailCF from "./PostDetailCF";
import PostDetailSummary from "./PostDetailSummary";
import PostDetailMessage from "./PostDetailMessage";
import moment from "moment";
import PostDetailPostProduct from "./PostDetailPostStock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideoCamera,
  faCartArrowDown,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import "./PostDetail.css";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_POST_STOCKS } from "../../../graphql/postStock/query";
// import { GET_STOCKS } from "../../../graphql/stock/query";
import { GET_ORDERS } from "../../../graphql/order/query";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import { useToasts } from "react-toast-notifications";
import { DELETE_POST } from "../../../graphql/post/mutation";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import BasicModal from "../../../components/BasicModal";
import { COLOR_APP, CREATED } from "../../../constants";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { moneyCurrency } from "../../../helpers";
import PostFacebookComment from "./PostFacebookComment";
import { CREATE_ORDER_FROM_FB_COMMENTS } from "../../../graphql/orderGroup/mutation";
import LoadingSpinner from "../../../components/LoadingSpinner";


function LiveDetail() {
  const { height, width } = useWindowDimensions();
  const { addToast } = useToasts();

  const { history } = useReactRouter();

  const [liveData, setLiveData] = useState();
  const [key, setKey] = useState("order");
  const LIMIT_PAGE = 100;
  const [postStocks, setPostStocks] = useState([]);
  const [postStocksTotal, setPostStocksTotal] = useState(0);
  const [orderTotal, setOrderTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  const [fbCommentSelect, setFbCommentSelect] = useState([]);
  const [allPrice, setAllPrice] = useState(0);
  const [allPriceBaht, setAllPriceBaht] = useState(0);
  const [allPriceUsd, setAllPriceUsd] = useState(0);
  const [peopleOrders, setPeopleOrders] = useState([]);
  const [totalOrder, setTotalOrder] = useState([]);
  const [postDetailSummary, setPostDetailSummary] = useState([]);
  const [showDeletePostConfirm, setShowDeletePostConfirm] = useState(false);
  const [showCreateOrderFbComments, setShowCreateOrderFbComments] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [liveOrderList, setLiveOrderList] = useState([]);
  // const [liveTotalOrderList, setLiveTotalOrderList] = useState([]);

  const [deletePost] = useMutation(DELETE_POST);
  const [updateStock] = useMutation(UPDATE_STOCK);

  const [createOrderFbComments, { data: createOrderFbCommentsData, loading: createOrderFbCommentsLoading }] = useMutation(CREATE_ORDER_FROM_FB_COMMENTS);
  const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });

  // const [getLiveStockData, { data: liveStockData }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getOrderData, { data: orderData, loading: orderLoading }] = useLazyQuery(GET_ORDERS, { fetchPolicy: "cache-and-network" });
  const [getPostStocks, { data: postStockData, loading: postStocksLoading }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });
  // const [getStocks, { data: stockData }] = useLazyQuery(GET_STOCKS, { fetchPolicy: "cache-and-network" });
 

  useEffect(() => {
    if (history.location.state.live) {
      // console.log("liveData: ", history.location.state.live);
      setLiveData(history.location.state.live);
    } else {
      history.goBack();
    }
  }, []);

  useEffect(() => {
    // console.log(liveData?.id)
    if (liveData?.id) {
      fetch();
    }
    initSetting()

  }, [liveData])

  useEffect(() => {
    // console.log({ postStockData })
    if (postStockData?.postStocks) {
      setPostStocks(postStockData?.postStocks?.data)
      setPostStocksTotal(postStockData?.postStocks?.total)
      setPageCountNumber(parseInt(postStockData?.postStocks?.total / LIMIT_PAGE) + 1)
    }
  }, [postStockData])

  // useEffect(() => {
  //   if (liveData) getLiveOrder()
  //   initSetting()
  // }, [liveData])

  useEffect(() => {
    // console.log("orderData", orderData);
    // set total price
    setTotalOrder(orderData?.orders?.total)

    // set all people order
    let _newpeopleOrders = _.groupBy(orderData?.orders?.data, "cfName");
    setPeopleOrders(Object.values(_newpeopleOrders));
    // console.log('Object.values(_newpeopleOrders)', Object.values(_newpeopleOrders))

    // set all price
    let _newAllPrice = orderData?.orders?.data?.reduce((sumPrice, order) => {
      if (['LAK', 'ກີບ'].includes(order?.currency)) return sumPrice + (order?.amount * order?.price)
      return sumPrice
    }, 0)
    let _newAllPriceBaht = orderData?.orders?.data?.reduce((sumPrice, order) => {
      if (['BAHT', 'ບາດ'].includes(order?.currency)) return sumPrice + (order?.amount * order?.price)
      return sumPrice
    }, 0)
    let _newAllPriceUsd = orderData?.orders?.data?.reduce((sumPrice, order) => {
      if (['USD', 'ໂດລາ'].includes(order?.currency)) return sumPrice + (order?.amount * order?.price)
      return sumPrice
    }, 0)
    setAllPrice(_newAllPrice);
    setAllPriceBaht(_newAllPriceBaht);
    setAllPriceUsd(_newAllPriceUsd);

    // set post detail summary
    let _newPostSummaryDetail = Object.values(_.groupBy(orderData?.orders?.data, 'cfMessage'));
    setPostDetailSummary(_newPostSummaryDetail);

  }, [orderData]);

  const fetch = async () => {
    try {
      getOrderData({
        variables: {
          where: {
            post: liveData?.id,
            isDeleted: false
          },
          skip: 0,
          limit: 1000
        }
      });
      getPostStocks({
        variables: {
          where: {
            post: liveData?.id,
            isDeleted: false,
          },
          limit: 1300,
          skip: 0,
          orderBy: "createdAt_DESC"
        }
      });
    } catch (err) {
      console.log(err)
    }
  }

  const getLiveOrder = async () => {
    try {
      //setIsLoading(true)
      await getOrderData({
        variables: {
          where: {
            post: liveData?.id,
            isDeleted: false
          },
          skip: 0,
          limit: 1000
        }
      })
      await getPostStocks({
        variables: {
          where: {
            post: liveData?.id,
            isDeleted: false
          },
          skip: 0,
          limit: 1300
        }
      })
    } catch (error) {
      console.log("Error retrieving posts", error);
    }
  }

  const initSetting = async () => {
    // setIsLoading(true)
    let SHOP_ID = await localStorage.getItem("SHOP");
    await getSettings({
      variables: {
        where: {
          shop: SHOP_ID
        },
        orderBy: "createdAt_ASC"
      }
    })
  }

  const _deletePost = async () => {
    if (liveData) {
      try {
        if (isLoading) return;
        setIsLoading(true);

        // const _postStocks = await getPostStocks({
        //   variables: {
        //     where: {
        //       post: liveData?.id,
        //       isDeleted: false
        //     },
        //     limit: 1300,
        //     skip: 0,
        //     orderBy: "createdAt_DESC"
        //   }
        // });

        // // console.log('_postStocks: ', _postStocks.data.postStocks.data)

        // await _postStocks?.data?.postStocks?.data.map(async (stock) => {
        //   await _updateStockWhenDeletePost(stock)
        // })

        /***************************
         * Delete live record
         **************************/
        await deletePost({
          variables: {
            where: {
              id: liveData?.id,
            },
          },
        });
        // setLoading(false);
        setIsLoading(false);

        triggerHideDeletePostConfirm();
        history.goBack();
        addToast("ລຶບໂພສສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
      } catch (err) {
        console.log(err);
        setIsLoading(false);
        addToast("ມີບາງຢ່າງຜິດພາດ ໃນການລຶບໂພສ", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  };


  const _updateStockWhenDeletePost = async (lStock) => {
    await updateStock({
      variables: {
        where: {
          id: lStock?.stock?.id,
        },
        data: {
          amount: lStock?.stock?.amount + lStock?.amount,
          isUsing: false,
        },
      },
    });
  };

  const handleCreateOrderFromFbComments = async () => {
    try{
      if(fbCommentSelect.length > 10) {
        addToast("ກະລຸນາກວດສອບຂໍ້ຄວາມຫ້າມຫຼາຍເກີນ 10 ຂໍຄວາມ", {
          appearance: "warning",
          autoDismiss: true,
        });
      }
      if(createOrderFbCommentsLoading) return;
      setIsLoading(true);
      const createOrder = await createOrderFbComments({
        variables: {
          where: JSON.stringify({
              page: liveData?.page,
              fbFeedId: liveData?.fbFeedId,
              post: liveData?.id
          }),
          data: JSON.stringify(fbCommentSelect),
        },
      });
      setIsLoading(false);
      if (createOrder?.data?.createOrderFbComments?.message !== "success") {
        addToast("ສ້າງອໍເດີສຳເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        setFbCommentSelect([]);
      } else {
        addToast("ສ້າງອໍເດີບໍ່ສຳເລັດ", {
          appearance: "error",
          autoDismiss: true,
        });
      }
      await fetch();
      setKey("order");
    } catch(error) {
      setKey("order");
      setIsLoading(false);
      addToast("ສ້າງອໍເດີບໍ່ສຳເລັດ", {
        appearance: "error",
        autoDismiss: true,
      });
      console.log("Error handleCreateOrderFromFbComments:", error);
      return;
    }
  };

  const triggerHideDeletePostConfirm = () => setShowDeletePostConfirm(false);
  const triggerHideCreateOrderFromFbComments = () => setShowCreateOrderFbComments(false);
  const triggerShowDeletePostConfirm = () => setShowDeletePostConfirm(true);

  if(createOrderFbCommentsLoading) return <LoadingSpinner />

  return (
    <div>
      <BasicModal show={showDeletePostConfirm} Illustration={'images/Illustration.png'} okay={_deletePost} onHide={triggerHideDeletePostConfirm} title="ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ຫຼື ບໍ່" leftButtonName="ຍົກເລີກ" rightButtonName="ຕົກລົງ" />
      <div
        style={{
          display: "flex",
          justifyItems: "center",
          background: "#F6F6F6",
          padding: "27.5px 13.5px 16px 16px",
        }}
      >
        {/* <Link to={"/"}> */}
        <button
          style={{
            fontSize: "16px",
            color: "#371895",
            margin: "0 10px",
            border: "none",
          }}
          onClick={() => history.replace("/post-feed")}
        >
          <FontAwesomeIcon
            icon={faVideoCamera}
            style={{ marginRight: "5px" }}
          />
          ຈັດການ Post
        </button>

        <button
          style={{
            margin: "0 10px",
            fontSize: "16px",
            color: "#252A31",
            cursor: "default",
            border: "none",
          }}
        >
          {'> '}ລາຍລະອຽດການໂພສ
        </button>
      </div>
      {/* <Breadcrumb>
                <Breadcrumb.Item onClick={() => history.replace('/live-manage')}>ຈັດການໄລຟ</Breadcrumb.Item>
                <Breadcrumb.Item active>ລາຍລະອຽດໄລຟffff</Breadcrumb.Item>
            </Breadcrumb> */}

      <div
        style={{
          borderRadius: "6px",
          flexFlow: "column",
          justifyContent: "space-between",
          alignItems: "start",
          pending: "5px",
          flexDirection: "column",
          background: "#F6F6F6",
        }}
      >
        <div style={{ background: '#fff', margin: "0px 16px", padding: '10px 16px' }}>
          <BasicModal show={showCreateOrderFbComments} Illustration={'images/Illustration.png'} 
            okay={handleCreateOrderFromFbComments} 
            onHide={triggerHideCreateOrderFromFbComments} 
            title="ທ່ານຕ້ອງການສ້າງອໍເດີຈາກເຟສບຸກຄອຍໍມເມັ້ນ ຫຼື ບໍ່" 
            leftButtonName="ຍົກເລີກ" 
            rightButtonName="ຕົກລົງ" 
          />
          <Row className="align-items-center justify-content-between">
            <Col>ລາຍລະອຽດການໂພສ</Col>
            <Col md="auto">
            {
                (key === "fbComment" && fbCommentSelect.length > 0) ? <button
                  onClick={() => handleCreateOrderFromFbComments()}
                  style={{
                    color: "#123524",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "6px",
                    padding: "10px 50px 20px",
                    background: "#5CB338",
                    border: 'none',
                    fontSize: "18px", // Set font size
                    height: "40px", // Set button height
                    width: "200px" // Set button width
                  }}
                >
                  <FontAwesomeIcon icon={faCartArrowDown} />
                  <p style={{ maginRight: "8px" }}></p>
                  ສ້າງອໍເດີ້({fbCommentSelect.length})
                </button> : ''
              }
              </Col>
            <Col xs lg="2" className="text-end">
            {
              liveData?.status === CREATED ? <button
                onClick={triggerShowDeletePostConfirm}
                style={{
                  color: "#D21C1C",
                  width: "103px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  padding: "5px 16px",
                  background: "#F6F6F6",
                  border: 'none'
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
                <p style={{ marginRight: "8px" }}></p>
                ລຶບໂພສ
              </button> : ''
            }
            </Col>
          </Row>

          <div className="row">
            <div className={width > 700 ? "col-1" : "col-3"} style={{ padding: 0, textAlign: 'end', whiteSpace: 'nowrap' }}>ຫົວຂໍ້ໂພສ:</div>
            <div className={width > 700 ? "col-11" : "col-9"} style={{
              color: "#5C5C5C", fontWeight: 600, whiteSpace: 'normal',
              wordWrap: 'break-word'
            }}> {
                liveData?.description === null ? "ບໍ່ມີຫົວຂໍ້" : liveData?.description
              }</div>
          </div>

          <div className="row">
            <div className={width > 700 ? "col-1" : "col-3"} style={{ padding: 0, textAlign: 'end', whiteSpace: 'nowrap' }}>ຊື່ເພຈ:</div>
            <div className={width > 700 ? "col-11" : "col-9"} style={{ color: "#5C5C5C", fontWeight: 600 }}>{liveData?.pageName}</div>
          </div>

          <div className="row">
            <div className={width > 700 ? "col-1" : "col-3"} style={{ padding: 0, textAlign: 'end', whiteSpace: 'nowrap' }}>ວັນທີ:</div>
            <div className={width > 700 ? "col-11" : "col-9"} style={{ color: "#5C5C5C", fontWeight: 600 }}>{moment(liveData?.createdAt).format("DD/MM/YYYY  HH:mm")}</div>
          </div>

        </div>

        <div
          style={{
            display: "flex",
            flexDirection: width > 700 ? 'row' : 'column',
            background: "white",
            margin: "0px 16px",
            padding: "24px 24px",
          }}
        >
          <div
            style={{
              background: "#F6F6F6",
              borderRadius: "6px",
              flex: 1,
              marginRight: "3px",
              padding: "16px 0px",
              textAlign: "center",
              margin: '5px 2px'
            }}
          >
            {" "}
            <p style={{ fontSize: "16px" }}>ຈຳນວນຄົນສັ່ງຊື້ {orderLoading && <Spinner size="sm" />}</p>
            <p className="money">
              {peopleOrders?.length ?? 0}
            </p> 
          </div>
          <div
            style={{
              background: "#F6F6F6",
              borderRadius: "6px",
              flex: 1,
              marginRight: "3px",
              padding: "16px 0px",
              // height: "118px",
              textAlign: "center",
              margin: '5px 2px'
            }}
          >
            {" "}
            <p style={{ fontSize: "16px" }}>ລວມຍອດອໍເດີ້ {orderLoading && <Spinner size="sm" />}</p>
           <p className="money">
              {totalOrder ?? 0}
            </p> 
          </div>
          <div
            style={{
              background: "#F6F6F6",
              borderRadius: "6px",
              flex: 1,
              marginRight: "3px",
              padding: "16px 0",
              textAlign: "center",
              margin: '5px 2px'
            }}
          >
            {" "}
            <p style={{ fontSize: "16px" }}>ຍອດລາຍຮັບທີ່ໄດ້ {orderLoading && <Spinner size="sm" />}</p>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <p className="money">{moneyCurrency(allPrice) + " ກີບ"} </p>
              <p className="money">{moneyCurrency(allPriceBaht) + " ບາດ"} </p>
              <p className="money">{moneyCurrency(allPriceUsd) + " ໂດລາ"} </p>
            </div>
          </div>
          <div
            style={{
              background: "#F6F6F6",
              borderRadius: "6px",
              flex: 1,
              padding: "16px 0px",
              textAlign: "center",
              margin: '5px 2px'
            }}
          >
            {" "}
            <p style={{ fontSize: "16px" }}>ຈຳນວນສິນຄ້າທີ່ເພີ່ມເຂົ້າ {orderLoading && <Spinner size="sm" />}</p>
            <p className="money">{Intl.NumberFormat("en-US").format(postStocksTotal ?? 0)}</p>
          </div>
        </div>
      </div>
      <div style={{ height: 15 }} />
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        {/* <Tab eventKey="message" title="ຂໍ້ຄວາມ">
          <PostDetailMessage liveData={liveData} />
        </Tab> */}
        <Tab eventKey="order" title="ຄົນສັ່ງຊື້">
          <PostDetailCF peopleOrders={peopleOrders} liveData={liveData} />
        </Tab>
        <Tab eventKey="home" title="ສະຫຼຸບຍອດ" >
          <PostDetailSummary postDetailSummary={postDetailSummary} liveData={liveData} />
        </Tab>
        <Tab eventKey="stock" title="ສິນຄ້າ">
          {/* setPostStocks ຈຳເປັນ — ຂ້າງໃນໃຊ້ມັນອັບເດດໜ້າຈໍຫຼັງເພີ່ມຈຳນວນ, ເປີດ/ປິດ ແລະ ລຶບ */}
          <PostDetailPostProduct liveData={liveData} postStocks={postStocks} setPostStocks={setPostStocks} />
        </Tab>
        <Tab eventKey="postComment" title="ຄອມເມັ້ນທັງໝົດ">
          <PostDetailMessage liveData={liveData} postStocks={postStocks} setPostStocks={setPostStocks} getOrderData={getOrderData} />
        </Tab>
        <Tab eventKey="fbComment" title="ຄອມເມັ້ນໃນເຟສບຸກ" >
          <PostFacebookComment 
            fbCommentSelect={fbCommentSelect} setFbCommentSelect={setFbCommentSelect}
            liveData={liveData} onTab={key} setLoading={setIsLoading} loading={isLoading} 
          />
        </Tab>
      </Tabs>
    </div >
  );
}

export default LiveDetail;
